// material
import {

    Card,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableContainer,
    Container,
} from '@material-ui/core';
// utils
import { RootState, useDispatch, useSelector } from 'redux/store';
import { useEffect } from 'react';
import { getOccupation } from 'redux/slices/occupation';
import Page from 'components/Page';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import useLocales from 'hooks/useLocales';
// ----------------------------------------------------------------------

export default function Occupations() {
    const { translate } = useLocales();
    const dispatch = useDispatch();
    const { occupationList } = useSelector(
        (state: RootState) => state.occupation
    );


    useEffect(() => {
        dispatch(getOccupation());
    }, [dispatch]);


    return (
        <>  <Page title="Occupations">
            <Container maxWidth="xl">

                <HeaderBreadcrumbs
                    heading={translate(`dashboard.${"Occupations"}`)}
                    links={[
                        // { name: 'Amount', href: PATH_DASHBOARD.user.root },
                        // { name: 'Delivery Options', href: PATH_DASHBOARD.user.root },
                    ]}
                />
                <Card sx={{ pb: 3 }}>
                    <TableContainer sx={{ minWidth: 720 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Occupation Id</TableCell>
                                    <TableCell>Occupation code</TableCell>
                                    <TableCell>Occupation text</TableCell>
                                </TableRow>
                            </TableHead>
                            {occupationList !== null &&
                                <TableBody>
                                    {occupationList.map((row) => (
                                        <TableRow key={row.occupationId}>
                                            <TableCell>{row.occupationId}</TableCell>
                                            <TableCell>{row.occupationCode}</TableCell>
                                            <TableCell>{row.occupationText}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>}
                        </Table>

                    </TableContainer>
                </Card>
            </Container>
        </Page></>
    );
}